import { useEffect, useRef } from 'react';
import useApiReducer from './useApiReducer';
import get from './api/get';
import handleApiError from './handleApiError';

export default function useThrottledGetRequest(url, { wait = 0 }) {
    const throttledRequestTimer = useRef(null);
    const nextRequest = useRef(null);
    const [state, actions] = useApiReducer({
        loading: true,
    });

    useEffect(() => {
        const abortController = new AbortController();

        function makeRequest() {
            if (abortController.signal.aborted) {
                return;
            }

            actions.loading();
            get(url, { signal: abortController.signal })
                .then((data) => {
                    if (!abortController.signal.aborted) {
                        actions.fetchComplete(data);
                    }
                })
                .catch((e) => {
                    handleApiError(url, e);
                    actions.error(true);
                });
        }

        if (!throttledRequestTimer.current || !wait) {
            makeRequest();
            if (wait) {
                throttledRequestTimer.current = setTimeout(() => {
                    nextRequest.current?.();
                    throttledRequestTimer.current = null;
                }, wait);
            }
        } else {
            nextRequest.current = makeRequest;
        }

        return () => abortController.abort();
    }, [actions, url, wait]);

    return [state.results, state.loading, state.error];
}
